(function () {
  function setup(desc) {
    if (desc.dataset.polished) return;
    desc.dataset.polished = 'true';

    if (desc.scrollHeight <= 170) {
      desc.classList.add('no-truncate');
      return;
    }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'product__description-toggle';
    toggle.innerHTML =
      '<span data-label>Read more</span>' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    toggle.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-expanded');
      toggle.classList.toggle('is-expanded', expanded);
      toggle.querySelector('[data-label]').textContent = expanded ? 'Read less' : 'Read more';
    });

    desc.parentNode.insertBefore(toggle, desc.nextSibling);
  }

  function run() {
    document.querySelectorAll('.product__description').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
